/**
 * Skip Navigation Component
 * Per WCAG 2.1 AA - allows keyboard users to skip to main content
 * Visually hidden, becomes visible on focus
 */
export function SkipNav() {
  return (
    <a
      href="#main-content"
      className="
        sr-only focus:not-sr-only
        focus:absolute focus:top-4 focus:left-4 focus:z-[100]
        focus:px-4 focus:py-2
        focus:bg-accent focus:text-bg-base
        focus:rounded-md focus:font-medium
        focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-bg-base
        transition-colors duration-150
      "
    >
      Mergi la conținutul principal
    </a>
  );
}
